import { event } from 'nextjs-google-analytics'

import { useEvent } from '@utsubo/events'

const AnalyticsTracking = () => {
  const tracking = (data) => {
    event(data.event, {
      category: data.category,
      label: data.label,
      value: data.value,
    })
  }

  useEvent('tracking', tracking)

  return null
}

export { AnalyticsTracking }
